import React from 'react';
import { 
  Landmark, 
  HeartPulse, 
  GraduationCap, 
  ShoppingCart, 
  Truck, 
  Home,
  Building2,
  Briefcase
} from 'lucide-react';
import './Industries.css';

const industries = [
  { icon: <Landmark size={40} />, name: 'FinTech' },
  { icon: <HeartPulse size={40} />, name: 'Healthcare' },
  { icon: <GraduationCap size={40} />, name: 'EdTech' },
  { icon: <ShoppingCart size={40} />, name: 'E-commerce' },
  { icon: <Truck size={40} />, name: 'Logistics' },
  { icon: <Briefcase size={40} />, name: 'SaaS Startups' },
  { icon: <Building2 size={40} />, name: 'Real Estate' },
  { icon: <Home size={40} />, name: 'Hospitality' },
];

const Industries = () => {
  return (
    <section className="industries section">
      <div className="container">
        <h2 className="section-title">Industries We <span className="blue-text">Serve</span></h2>
        <p className="section-subtitle">
          We have deep domain expertise across various industries, delivering tailored solutions for each sector.
        </p>

        <div className="industries-grid">
          {industries.map((industry, index) => (
            <div key={index} className="industry-card">
              <div className="industry-icon">{industry.icon}</div>
              <h3>{industry.name}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;